module.exports = __webpack_public_path__ + "static/media/ghibli.461378be.GIF";